import Cookies from 'js-cookie';

const app = {
  state: {
    sidebar: {
      opened: !+Cookies.get('sidebarStatus')
    },
    theme: 'default',
    livenewsChannels: Cookies.get('livenewsChannels') || '[]',
    visitedViews: [],
    selectState:"home",
    searchWord:"",
    investmentParam:{param:{},conditions:[]},
    companyParam:{search:"",accu:""},
    fromPath : "",
    sidebarBigWidth: 230,
    sidebarSmallWidth:220,
    sidebarCriticalValue:2800,
    publicKey: null,
    effectiveTime: 0,
    publicKeyStoreTime: 0,
    unitCode: null
  },
  mutations: {
    TOGGLE_SIDEBAR: state => {
      if (state.sidebar.opened) {
        Cookies.set('sidebarStatus', 1);
      } else {
        Cookies.set('sidebarStatus', 0);
      }
      state.sidebar.opened = !state.sidebar.opened;
    },
    ADD_VISITED_VIEWS: (state, view) => {
      if (state.visitedViews.includes(view)) return
      state.visitedViews.push(view)
    },
    DEL_VISITED_VIEWS: (state, view) => {
      const index = state.visitedViews.indexOf(view)
      state.visitedViews.splice(index, 1)
    },
    SET_SELECT_STATE:(state, value) =>{
       state.selectState = value;
    },
    SET_SEARCH_WORD:(state, value) =>{
      state.searchWord = value;
    },
    SET_INVESTMENT_PARAM:(state,param,conditions) =>{
      state.investmentParam.param = param;
      state.investmentParam.conditions = conditions;
    },
    SET_COMPANY_PARAM:(state,value) =>{
      state.companyParam.search = value.search;
      state.companyParam.accu = value.accu;
    },
    SET_FROM_PATH:(state,value) =>{
      state.fromPath = value;
    },
    SET_PUBLIC_KEY:(state,publicKey) => {
      state.publicKeyStoreTime = new Date().valueOf();
      state.publicKey = publicKey;
    },
    SET_EFFECTIVE_TIME:(state,effectiveTime) => {
      state.effectiveTime = effectiveTime;
    },
    SET_UNIT_CODE: (state,unitCode) => {
      state.unitCode = unitCode;
    }
  },
  actions: {
    ToggleSideBar: ({ commit }) => {
      commit('TOGGLE_SIDEBAR')
    },
    addVisitedViews: ({ commit }, view) => {
      commit('ADD_VISITED_VIEWS', view)
    },
    delVisitedViews: ({ commit }, view) => {
      commit('DEL_VISITED_VIEWS', view)
    },
    setSelectState: ({ commit }, value) => {
      commit('SET_SELECT_STATE', value)
    },
    setSearchWord: ({ commit }, value) => {
      commit('SET_SEARCH_WORD', value)
    },
    setInvestmentParam: ({ commit },value) => {
      commit('SET_INVESTMENT_PARAM',value.param,value.conditions)
    },
    setCompanyParam: ({ commit },value) => {
      commit('SET_COMPANY_PARAM',value)
    },
    setFromPath: ({ commit },value) => {
      commit('SET_FROM_PATH',value)
    },
  }
};

export default app;



// WEBPACK FOOTER //
// ./src/store/modules/app.js